class Sweepstake {
    constructor() {
        this.container = document.querySelector('.js-sweepstake');
        this.form = document.querySelector('.js-sweepstake form');
    }

    init() {
        if (this.container && this.form) {
            this.bindEvents();
        }
    }

    bindEvents() {
        let _container = this.container;
        let _form = this.form;
        this.form.addEventListener('submit', function(event) {
            event.preventDefault();

            fetch(_form.action, { method:'post', body: new FormData(_form) })
                .then(function(response) {
                    return response.json();
                })
                .then(function(response) {
                    console.log(response);
                    if (response.success) {
                        _container.querySelector('.js-sweepstake-content').remove();
                        _container.querySelector('.js-sweepstake-success').classList.remove('is-hidden');
                        document.dispatchEvent(new Event('sweepstake.success'));
                    }
                })
                .catch(function(error) {
                    console.error(error);
                });
        });

        document.addEventListener('sweepstake.success', () => {
            this.updateModalLinks();
            this.triggerOpenerModal()
        });
    }

    updateModalLinks() {
        const container = document.querySelector('.js-sweepstake-modal');
        const formLinks = container.querySelectorAll('[href="#modal-sweepstake-form"]');

        formLinks.forEach((link, index) => {
            link.setAttribute('href', link.dataset.href);
        });
    }

    triggerOpenerModal() {
        const container = document.querySelector('.js-sweepstake');
        const openerTarget = container.dataset.openerTarget;

        if (openerTarget) {
            window.setTimeout(function() {
                window.open(openerTarget, '_blank');
            }, 500);
        }
    }
}

export default new Sweepstake();
